var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"1px"}},[(_vm.isBusy)?_c('span',{staticClass:"animated flip infinite",staticStyle:{"color":"white","margin-left":"50%"}},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }